import { SET, RESET_STATE } from "@/stores/CommumActionTypes";

const mutations = {
	[SET]: (state, menu) =>
	{
		state.menu = menu;
	},
	[RESET_STATE]: (state) =>
	{
		state.menu = [];
	},
};

export default { mutations };
